














import { Component, Vue } from 'vue-property-decorator'
import FileTree from '@/components/FileTree/index.vue'

@Component({
  name: 'DocumentsPage',
  components: {
    FileTree
  }
})
export default class extends Vue {
  // Логика страницы
}
